import { useEffect, useRef } from "react";

export function useScrollDirection() {
  const lastScrollTop = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;

      if (st > lastScrollTop.current) {
        document.documentElement.setAttribute("scroll-dir", "down");
      } else {
        document.documentElement.setAttribute("scroll-dir", "up");
      }

      lastScrollTop.current = Math.max(0, st);
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
}
